module.exports = __webpack_public_path__ + "img/peter.536e7e82.png";